/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowLoopLeft2 = createReactComponent("arrow-loop-left-2", "IconArrowLoopLeft2", [
  ["path", { d: "M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13", key: "svg-0" }],
  ["path", { d: "M8 16l-4 -4l4 -4", key: "svg-1" }]
]);

export { IconArrowLoopLeft2 as default };
//# sourceMappingURL=IconArrowLoopLeft2.js.map
